import {t} from "i18next";

export const ALL_JOB_POSITIONS = - 1
export const ALL_JOB_POSITIONS_TEXT = t("tnp.components.objectAssign.all")
export const OTHER_JOB_POSITIONS = 0
export const SUBMIT = "submit"
export const SUBMIT_AND_SAVE = "submitAndSave"
export const SUBMIT_AND_SEND = "submitAndSend"
export const STATUS_DRAFT = "draft"
export const STATUS_PENDING = "pending"
export const MODULE_CODE = "TIMEKEEPING"
export const APP_CODE_SALARY = "SALARY"
export const APP_CODE = "SHIFT_WORK"
export const TIME_OUT = 500
export const TYPE_QUICK_ADD = "quickAddShiftConfig"
export const assignType = {
    employees: "employees",
    departments: "departments",
}

export const assignmentType = {
    weekly : "weekly",
    fixed_date : "fixed_date",
    period : "period",
    date_range : "date_range"
}



